import { ApolloClient, createHttpLink, gql, InMemoryCache, TypedDocumentNode } from '@apollo/client';
import {
    Mutation,
    MutationDeleteNoteArgs,
    MutationSaveNoteArgs,
    Query,
    QueryNoteArgs
} from 'sr-types/lib/note/v1/graphql';
import { authLink } from '../../auth/api';
import { ReferenceFragment, ShareAccessFragment } from '../../list/fragments';

export const client = new ApolloClient({
    link: authLink.concat(
        createHttpLink({
            uri: '/note/v1/'
        })
    ),
    cache: new InMemoryCache({
        addTypename: false
    })
});

export const saveNote: TypedDocumentNode<Pick<Mutation, 'saveNote'>, MutationSaveNoteArgs> = gql`
    mutation SaveNote($input: NoteInput!) {
        saveNote(input: $input) {
            id
            errors {
                field
                message
            }
            reference {
                ...Reference
            }
        }
    }
    ${ReferenceFragment}
`;

export const removeNote: TypedDocumentNode<Pick<Mutation, 'deleteNote'>, MutationDeleteNoteArgs> = gql`
    mutation DeleteNote($id: ID!) {
        deleteNote(id: $id) {
            id
            errors {
                field
                message
            }
        }
    }
`;

export const getNote: TypedDocumentNode<Pick<Query, 'note'>, QueryNoteArgs> = gql`
    query note($id: ID!) {
        note(id: $id) {
            title
            content
            labels
            createdOn
            updatedOn
            contentType
            reference {
                ...Reference
            }
            entityReference {
                ...Reference
            }
            security {
                allowedActions
            }
            restricted
            sharedWithAccounts {
                ...ShareAccess
            }
            sharedWithDepartments {
                ...ShareAccess
            }
            createdByName
            updatedByName
            createdBy
        }
    }
    ${ReferenceFragment}
    ${ShareAccessFragment}
`;
